import React from "react";
import "./Sections.scss";
import img1 from "../../assets/walking-through-verona/img1.png";
import img2 from "../../assets/interview4/inline1.png";
import Quotes1 from "../Quotes/Quotes1";

function WalkingThroughVerona() {
  return (
    <section className="walking">
      <div className="walking__top">
        <div className="walking__quote">
          <Quotes1 />
        </div>
        <div className="walking__img1">
          <img className="walking__img1__img" src={img1} alt="" />
          <p className="caption walking__img1__caption">
            Roberto stands by Castelvecchio, a fortress built by Verona’s
            Scaliger dynasty in the 14th century.
          </p>
        </div>
      </div>
      <div className="walking__frame">
        <div className="walking__content">
          <p className="walking__content__title walking__content__title--desktop">
            Roberto Coin has traveled the world
          </p>

          <p className="walking__content__copy">
            <span className="walking__content__title walking__content__title--mobile">
              Roberto Coin has traveled the world
            </span>{" "}
            in search of beautiful inspirations for the jewelry that bears his
            name. “I find beauty everywhere,” he says, “in nature, in people, in
            architecture, in art and in food.” And his collections bear that
            out: since starting the brand in 1996, he’s taken inspiration from a
            wide variety of sources, from the natural world in Animalier, to the
            stars, with his Zodiac Medallions.
          </p>
          <p className="walking__content__copy">
            Still, few places inspire Coin like his native Italy. When you’re
            walking through Verona—or any Italian city—with Roberto Coin, you
            can’t expect to get anywhere fast. Every couple steps he stops to
            point out another beautiful thing—the design of the rosoni
            medallions on a building’s facade, or the red brick merlons of
            Castelvecchio. Now he’s paused to admire the Ponte Pietra, a Roman
            bridge completed around 100 BC and still in use today. “Even when
            I’m by myself, I am never alone,” says Roberto. “Walking through
            this city is like watching a film for me, I can go back in my mind
            and see what it used to be in those days.”
          </p>
          <p className="walking__content__copy">
            Today, he’s in Italy’s città dell’amore, Verona, where he spoke
            about his process, his philosophy of life, and the origins of his
            new “Love in Verona” collection.
          </p>

          <div className="walking__content__img2">
            <img className="walking__content___img2__img" src={img2} alt="" />
            <p className="caption walking__content___img2__caption">
              Verona, Italy as seen from Castel San Pietro.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WalkingThroughVerona;
